import { doGet } from '../../helpers';

export const messaging = {
  getRespondioRedirectURL: (email: string) =>
    doGet<{url: string}>(`/dashboard/messaging/respondio/${email}`),
  getZendeskRedirectURL: (email: string) =>
    doGet<{url: string}>(`/dashboard/messaging/zendesk/${email}`)
};
